import { ref } from "vue";
import { severityCode } from "@/services/api/httpClient";

export default function useGrid27({
  getData,
  fetchDataError,
  fetchDataStart,
  fetchDataComplete,
  initialPageSize = 10,
}) {
  const gridData = ref([]);
  const gridSorting = ref({ by: undefined, desc: false });
  const gridIsLoading = ref(false);

  const pageNumber = ref(0);
  const pageSize = ref(initialPageSize);
  const pageCount = ref(0);
  const totalItems = ref(0);

  const fetchCount = ref(0);

  function changedSortBy(message) {
    gridSorting.value.by = message.length > 0 ? message[0].key : undefined;
    gridSorting.value.desc = message.length > 0 ? message[0].order === "desc" : false;
    fetchFirstPage();
  }

  //obsolete: gebruiken alleen sort vervangen door changedSortBy
  function changedOptions(message) {
    gridSorting.value.by = message.sortBy.length > 0 ? message.sortBy[0].key : undefined;
    gridSorting.value.desc = message.sortBy.length > 0 ? message.sortBy[0].order === "desc" : false;
    fetchFirstPage();
  }

  async function fetchFirstPage() {
    await fetchData(1, pageSize.value, gridSorting.value.by, gridSorting.value.desc);
  }

  async function fetchData(fetchPageNumber, fetchPageSize, sortBy, sortDesc) {
    fetchCount.value++;
    if (fetchDataStart) {
      fetchDataStart({ fetchCount: fetchCount.value });
    }

    gridIsLoading.value = "#00a3e0";
    const response = await getData(fetchPageNumber, fetchPageSize, sortBy, sortDesc);
    gridIsLoading.value = null;

    let loadedCount = 0;
    if (response) {
      if (response.severity != severityCode.error && response.data) {
        totalItems.value = response.data.totalNumber;
        pageNumber.value = fetchPageNumber;
        pageSize.value = fetchPageSize;
        pageCount.value = response.data.lastPage;
        gridData.value = [...(response.data.data ?? [])];
        loadedCount = gridData.value.length;
      } else {
        if (fetchDataError) {
          fetchDataError(response.message);
        }
        //this.$toaster.error("Ophalen van de data is mislukt! " + response.message);
      }
    }
    if (fetchDataComplete) {
      fetchDataComplete({ count: loadedCount, totalCount: totalItems.value, fetchCount: fetchCount.value });
    }
  }

  function changedPaging(paging) {
    fetchData(paging.pageNumber, paging.pageSize, gridSorting.value.by, gridSorting.value.desc);
  }

  function changePageSize(nePageSize) {
    pageSize.value = nePageSize;
  }

  return { fetchFirstPage, gridData, gridSorting, gridIsLoading, pageNumber, pageSize, pageCount, totalItems, changedOptions, changedSortBy, changedPaging, changePageSize };
}
